module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_Left.647a54e7.jpg";